import React from "react";
// import brochurePdf from "../../../public/TechInstituteBrochure.pdf"

const HeroSection = () => {
  const handleDownloadBrochure = () => {
    const link = document.createElement('a');
    link.href = '/TechInstituteBrochure.pdf';
    link.download = 'TechInstituteBrochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExploreCourses = () => {
    const coursesSection = document.getElementById('our-courses');
    if (coursesSection) {
      coursesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative bg-gradient-to-br from-blue-900 to-blue-800 rounded-3xl mx-4 my-8 overflow-hidden">
      <div className="absolute top-10 right-10 w-32 h-32 bg-blue-400 rounded-full opacity-20"></div>
      <div className="absolute bottom-10 left-10 w-24 h-24 bg-blue-300 rounded-full opacity-30"></div>
      <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-blue-200 rounded-full opacity-25"></div>
      
      <div className="relative z-10 px-8 py-16 text-center">
        <h1 className="text-2xl md:text-5xl font-bold text-white mb-6 leading-tight">
        Transform Your Future with Next-Gen Tech Education
        </h1>
        <p className="text-sm md:text-base text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          At INSYTIX Tech Institute, we deliver future-focused training programs designed to bridge the gap between academic learning and industry expectations. Learn directly from seasoned professionals, gain practical exposure, and build the skills that global employers demand.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={handleExploreCourses}
            className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition duration-300"
          >
            Explore Courses
          </button>
          {/* <button 
            onClick={handleDownloadBrochure}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition duration-300"
          >
            Download Brochure
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
